import { render, staticRenderFns } from "./date-range-widget.vue?vue&type=template&id=be54eadc&scoped=true&"
import script from "./date-range-widget.vue?vue&type=script&lang=js&"
export * from "./date-range-widget.vue?vue&type=script&lang=js&"
import style0 from "./date-range-widget.vue?vue&type=style&index=0&id=be54eadc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be54eadc",
  null
  
)

export default component.exports